<template>
    <span>{{ result }}</span>
</template>

<script>
import { computed, defineComponent } from "vue";
import { dateFormat } from "../../../utils/date";

export default defineComponent({
    props: {
        text: {},
        format: {},
    },
    setup(props) {
        const result = computed(() => dateFormat({ text: props.text, format: props.format }));
        return { result };
    },
});
</script>
